import {
  NgModule
} from '@angular/core';
import {NavigationComponent} from './navigation.component';
import {UserContext} from '../../../../services/user-context';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {MatIcon, MatIconModule} from '@angular/material/icon';


@NgModule({

  imports: [
    ButtonsModule,
    CommonModule,
    RouterModule,
    MatIconModule
  ],
  declarations: [
    NavigationComponent
  ],
  exports: [
    NavigationComponent
  ],
  providers: [
    UserContext
  ],
  entryComponents: [],
})
export class NavigationModule {
}
